// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

export const AuthContext = React.createContext();
